import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  exemploMinimalistaURL = '';
  constructor() {
  }

  ngOnInit() {
    this.exemploMinimalistaURL = environment.minimalistUrl;
  }
  
}



// WEBPACK FOOTER //
// /home/fabiano/git/assinador-showcase/frontend/src/app/home/home.component.ts